// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressContent__subcontainer___2-6PS{padding:0 24px}.PressContent__inner___3nKI-{display:flex;flex-direction:column;align-items:center;padding:80px 0 160px}@media (min-width:960px){.PressContent__inner___3nKI-{flex-direction:row;align-items:inherit;justify-content:space-between}}.PressContent__sidebar___23Q2z{flex-grow:1;min-width:0;max-width:620px}@media (min-width:960px){.PressContent__sidebar___23Q2z{min-width:300px;max-width:475px;margin-right:80px}}.PressContent__article___1k9Hr{flex-grow:1;max-width:620px;margin-top:80px}@media (min-width:960px){.PressContent__article___1k9Hr{margin-top:0}}.PressContent__image___2hgH8{width:100%;height:330px;border-radius:8px;-o-object-fit:cover;object-fit:cover}.PressContent__intro___3JOUK{margin-top:80px}.PressContent__intro___3JOUK *{color:inherit;font-weight:400;font-size:20px;line-height:32px;color:#2c2302}.PressContent__summary___KkrHA{color:#6b6651}.PressContent__link___3SAHx,.PressContent__summary___KkrHA{margin-top:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"subcontainer": "PressContent__subcontainer___2-6PS",
	"inner": "PressContent__inner___3nKI-",
	"sidebar": "PressContent__sidebar___23Q2z",
	"article": "PressContent__article___1k9Hr",
	"image": "PressContent__image___2hgH8",
	"intro": "PressContent__intro___3JOUK",
	"summary": "PressContent__summary___KkrHA",
	"link": "PressContent__link___3SAHx"
};
module.exports = ___CSS_LOADER_EXPORT___;
